module.exports = __webpack_public_path__ + "media/styles/images/svg/pen-gray-light-2328c1fbe452e656b267d2ae12ef26dd.svg";